module.exports = __webpack_public_path__ + "static/img/16.419bf99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/16.jpg
// module id = 8d6/
// module chunks = 16